var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"loader-wrapper",class:{ loderhide: !_vm.isLoading }},[_vm._m(0)]),_c('notifications',{attrs:{"group":"notify","ignore-duplicates":true}}),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-box"},[_c('div',{staticClass:"loader-19"})])
}]

export { render, staticRenderFns }